module.exports = __webpack_public_path__ + "fonts/SofiaProMedium-Italic.88ca539a.eot";